import dynamic from 'next/dynamic';
import { Fragment } from 'react';
import { NextSeo } from 'next-seo';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Skelet from '../components/Skelet';
import css from '../styles/modules/favorites/Favorites.module.scss';

const FavoritesStatistic = dynamic(() =>
  import('../components/favorites/FavoritesStatistic'), {
    loading: () => (
      <section className="block">
        <div className="fixed">
          <div className={css.statistics}>
            <Skelet height={120} width={120} className={css.statisticsGraph} />
            <Skelet height={120} className={css.statisticsContent} />
          </div>
        </div>
      </section>
    )
  }
);
const FavoritesList = dynamic(() =>
  import('../components/favorites/FavoritesList'), {
    loading: () => (
      <section className="block">
        <div className="fixed">
          <div className={css.list}>
            <div className={css.listHeader}>
              <Skelet height={33} maxWidth={200} className={css.listHeaderTitle} />
            </div>
            <div className={css.listContent}>
              {[...Array(3).keys()].map((value) => (
                <div className={css.listItem} key={value}>
                  <div className={css.listItemGallery}>
                    <div className={css.listItemGalleryPhoto}>
                      <Skelet style={{ position: 'absolute', height: '100%', borderRadius: 20 }} />
                    </div>
                  </div>
                  <div className={css.listItemData}>
                    <Skelet className={css.listItemPrice} height={33} maxWidth={200} />
                    <Skelet className={css.listItemAddress} height={21} maxWidth={240} />
                    <div className={css.listItemProperties}>
                      <Skelet
                        className={css.listItemProperty}
                        width={60}
                        height={32}
                        style={{ marginRight: 12 }}
                      />
                      <Skelet
                        className={css.listItemProperty}
                        width={60}
                        height={32}
                        style={{ marginRight: 12 }}
                      />
                      <Skelet
                        className={css.listItemProperty}
                        width={60}
                        height={32}
                        style={{ marginRight: 12 }}
                      />
                    </div>
                    <Skelet className={css.listItemDescription} height={110} />
                    <div className={css.listItemActions}>
                      <div className={css.listItemDate} />
                      <Skelet width={150} height={44} style={{ borderRadius: 18 }} />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    )
  }
);

const FavoritesPage = () => {
  return (
    <Fragment>
      <NextSeo
        noindex
        nofollow
        title="Избранное"
        description="Избранное: объекты недвижимости."
        openGraph={{
          url: `https://${process.env.NEXT_PUBLIC_SITEDOMAIN}`,
          type: 'website',
          title: 'Избранное',
          description:
            'Избранное: объекты недвижимости',
          images: [
            {
              url: '/images/og-preview.png'
            }
          ],
          site_name: process.env.NEXT_PUBLIC_SITENAME
        }}
      />
      <Header />
      <main className="core">
        <FavoritesStatistic />
        <FavoritesList />
      </main>
      <Footer />
    </Fragment>
  );
};

export default FavoritesPage;
